/**
 * Stop-words and noise to drop from pivot context (EN + common UI crumbs).
 */
const STOP_WORDS = new Set(
  [
    'a',
    'an',
    'the',
    'and',
    'or',
    'but',
    'in',
    'on',
    'at',
    'to',
    'for',
    'of',
    'as',
    'is',
    'was',
    'are',
    'be',
    'been',
    'being',
    'have',
    'has',
    'had',
    'do',
    'does',
    'did',
    'will',
    'would',
    'could',
    'can',
    'may',
    'might',
    'must',
    'with',
    'from',
    'by',
    'via',
    'about',
    'into',
    'over',
    'after',
    'before',
    'your',
    'my',
    'our',
    'their',
    'this',
    'that',
    'these',
    'those',
    'it',
    'its',
    'linkedin',
    'com',
    'www',
    'http',
    'https',
    'profile',
    'view',
  ].map((w) => w.toLowerCase())
);

/** Trim junk from start/end of a phrase (dashes, slashes, dots, pipes, plus signs, commas). */
function stripEdgeNoise(s) {
  return String(s || '')
    .replace(/^[\s\-–—+./|\\:;,_•·]+|[\s\-–—+./|\\:;,_•·]+$/g, '')
    .trim();
}

/**
 * Short pivot string for context_focus: no name repeat, no stop-words, 3–4 tokens max.
 * @param {string} raw - title + snippet
 * @param {string} searchName - person name in search input
 */
export function cleanContext(raw, searchName) {
  let t = String(raw || '')
    .replace(/[\r\n\t]+/g, ' ')
    .replace(/[^\p{L}\p{N}\s]/gu, ' ');
  t = t.replace(/\s+/g, ' ').trim();
  if (!t) return '';

  const nameParts = String(searchName || '')
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .filter((w) => w.length > 0);
  const nameSet = new Set(nameParts);

  const words = t.split(/\s+/).filter(Boolean);
  const out = [];
  for (const w of words) {
    const core = stripEdgeNoise(w);
    if (!core) continue;
    const lw = core.toLowerCase();
    if (nameSet.has(lw)) continue;
    if (STOP_WORDS.has(lw)) continue;
    if (core.length <= 1 && !/\d/.test(core)) continue;
    out.push(core);
    if (out.length >= 4) break;
  }

  let phrase = out.join(' ');
  phrase = stripEdgeNoise(phrase);
  return phrase.slice(0, 120);
}
